import { BaseFetch } from "../main-model"
export default class ReligionModel extends BaseFetch {
    getReligionBy = (data) =>
        this.authFetch({
            url: "religion/getReligionBy",
            method: "POST",
            body: JSON.stringify(data),
        })
    getReligionById = (data) =>
        this.authFetch({
            url: "religion/getReligionById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updateReligionById = (data) =>
        this.authFetch({
            url: "religion/updateReligionById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertReligion = (data) =>
        this.authFetch({
            url: "religion/insertReligion",
            method: "POST",
            body: JSON.stringify(data),
        })
    deleteReligionById = (data) =>
        this.authFetch({
            url: "religion/deleteReligionById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
